import React, {useContext, useState, useEffect, useRef} from 'react';
import TrackList from './TrackList';
import AlbumList from './Album/AlbumList';  // Adjust the path if necessary

import withRouter from 'components/helpers/withRouter';
import {WidgetHead} from 'components/common/DisplayElems';
import {TracksContext} from 'context/TracksContext';
import {BounceLoader} from "react-spinners";
import {useDropzone} from 'react-dropzone';

function AddBanner({match, history}) {
    const bannerId = match && match.params ? match.params.id : undefined;
    const isEditMode = !!bannerId;
    const { 
        isBannerAdding, 
        isBannerAdded, 
        createBanner, 
        updateBanner,
        removeBannerTrack, 
        bannerTracks, 
        bannerTracksUp,
        resetBannerTrack,
        fetchBannerById,
        fetchBannerTracks,
        addBannerTrack,
        addBannerAlbum,
        currentBanner,
        isBannerFetchingById
    } = useContext(TracksContext);
    const [isBannerAddedd, setIsBannerAddedd] = useState(isBannerAdded);
    const [bannerImage, setBannerImage] = useState('');
    const [banner, setBanner] = useState('');
    // const [bannerOrder, setBannerOrder] = useState(1);
    const [endDate, setEndDate] = useState('');
    const [title, setTitle] = useState('');
    const [bannerType, setBannerType] = useState('tracks');
    const [bannerKeyword, setBannerKeyword] = useState('');
    const [bannerUrl, setBannerUrl] = useState('');
    const fileInputRef = useRef(null);
    // Validate keywords: split by comma, trim each, filter empty, check if any remain
    const keywordArray = bannerKeyword.split(',').map(k => k.trim()).filter(k => k.length > 0);
    const hasValidKeywords = keywordArray.length > 0;

    // Sync bannerTracksUp to bannerTracks when in edit mode (fallback if direct loading didn't work)
    useEffect(() => {
        if (isEditMode && bannerTracksUp && bannerTracksUp.length > 0 && bannerTracks.length === 0) {
            // Add all from bannerTracksUp to bannerTracks (only if bannerTracks is empty to avoid duplicates)
            bannerTracksUp.forEach(item => {
                if (item && !bannerTracks.find(t => t && t.id === item.id)) {
                    addBannerTrack(item);
                }
            });
        }
    }, [bannerTracksUp, isEditMode, bannerTracks.length]);

    useEffect(() => {
        console.log('Current bannerType:', bannerType); 
        if (!isEditMode) {
            resetBannerTrack();
            setBannerKeyword('');
        }
    }, [bannerType, isEditMode]);
    
    useEffect(() => {
        if (isBannerAdded === true) {
            setIsBannerAddedd(isEditMode ? 'Banner updated successfully' : 'Banner added successfully');
           
            setTimeout(() =>{
                // Preserve offset from URL query parameter when returning to banner list
                const queryParams = new URLSearchParams(window.location.search);
                const offset = queryParams.get('offset');
                const redirectUrl = offset !== null ? `/banner/all?offset=${offset}` : '/banner/all';
                window.location.href = redirectUrl;
              }, 3000);
        }
    }, [isBannerAdded, isEditMode]);
    const handelRemoveTrack = (track) => {
        removeBannerTrack(track)
    }
    // Function to get today's date in YYYY-MM-DD format
    const getCurrentDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        let month = today.getMonth() + 1;
        let day = today.getDate();

        // Ensure month and day are two digits
        if (month < 10) {
            month = `0${month}`;
        }
        if (day < 10) {
            day = `0${day}`;
        }

        return `${year}-${month}-${day}`;
    };
    // Get current date in YYYY-MM-DD format
    const currentDate = getCurrentDate();
    const [startDate, setStartDate] = useState(currentDate);
    const handleSubmit = (e) => {
        e.preventDefault();
        // Construct the data object to send to API
        const formData = {
          banner,
          startDate,
          endDate,
          title,
        // bannerOrder,
          bannerType,
          bannerUrl,
          keyword: bannerKeyword.trim(), // Send comma-separated keywords as-is
          targetBlank,
          resetForm
        };
    
        // Call API submission function from context
        if (isEditMode) {
          formData.bannerId = bannerId;
          updateBanner(formData);
        } else {
          createBanner(formData);
        }
      };
    const onDrop = (acceptedFiles) => {
        // Handle dropped files
        console.log('Accepted files:', acceptedFiles);
        // Assuming you want to set the first accepted file as banner
        if (acceptedFiles.length > 0) {
            setBanner(acceptedFiles[0]);
            const reader = new FileReader();
            reader.onloadend = () => {
                setBannerImage(reader.result);
            };
            reader.readAsDataURL(acceptedFiles[0]);
        }
    };
    const { getInputProps } = useDropzone({
        onDrop: onDrop
    });
    const resetForm = () => {
        resetFileInput();
        setStartDate('');
        setEndDate('');
        setTitle('');
        setBanner('');
        setBannerImage('');
        // setBannerOrder(1);
        setBannerType('tracks');
        setBannerUrl('');
        setBannerKeyword('');
    };
    const resetFileInput = () => {
        if (fileInputRef.current) {
            fileInputRef.current.value = ''; // Reset file input value
        }
    };
    useEffect(() => {
        if (isBannerAdding === true) {
            //getTracks(fields);
        }
    }, [isBannerAdding]);
    // Load banner data when in edit mode
    useEffect(() => {
        if (isEditMode && bannerId) {
            const loadBannerData = async () => {
                try {
                    resetBannerTrack(); // Clear existing tracks first
                    const banner = await fetchBannerById(bannerId);
                    if (banner) {
                        setTitle(banner.title || '');
                        setStartDate(banner.start ? new Date(banner.start).toISOString().split('T')[0] : currentDate);
                        setEndDate(banner.end ? new Date(banner.end).toISOString().split('T')[0] : '');
                        setBannerType(banner.bannerType || banner.type || 'tracks');
                        setBannerUrl(banner.bannerUrl || '');
                        // Handle targetBlank: could be 0/1 (number) or true/false (boolean)
                        const targetBlankValue = banner.targetBlank === 1 || banner.targetBlank === true || banner.targetBlank === '1';
                        setTargetBlank(targetBlankValue);
                        setBannerKeyword(banner.keyword || banner.searchKeyword || '');
                        setBannerImage(banner.banner || '');
                        setBanner(banner.banner || ''); // Set existing banner path
                        
                        // Load tracks or albums if banner type is tracks or album
                        if (banner.bannerType === 'tracks' || banner.type === 'tracks') {
                            const tracksResponse = await fetchBannerTracks({ bannerId: banner.id, bannerType: 'tracks' });
                            // Directly add tracks to bannerTracks after fetching
                            if (tracksResponse && Array.isArray(tracksResponse) && tracksResponse.length > 0) {
                                tracksResponse.forEach(track => {
                                    if (track && !bannerTracks.find(t => t && t.id === track.id)) {
                                        addBannerTrack(track);
                                    }
                                });
                            }
                        } else if (banner.bannerType === 'album' || banner.type === 'album') {
                            const albumsResponse = await fetchBannerTracks({ bannerId: banner.id, bannerType: 'album' });
                            // Directly add albums to bannerTracks after fetching
                            if (albumsResponse && Array.isArray(albumsResponse) && albumsResponse.length > 0) {
                                albumsResponse.forEach(album => {
                                    if (album && !bannerTracks.find(t => t && t.id === album.id)) {
                                        addBannerAlbum(album);
                                    }
                                });
                            }
                        }
                    }
                } catch (error) {
                    console.error('Error loading banner data:', error);
                }
            };
            loadBannerData();
        } else {
            resetForm();
            resetBannerTrack();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [bannerId]);

    // const handleBannerOrderChange = (bannerOrder) => {
    //     if(bannerOrder > 0){
    //         setBannerOrder(bannerOrder);
    //     }else{
    //         setBannerOrder(1);
    //     }
    // }
    const [targetBlank, setTargetBlank] = useState(false);
    return <><div className="col-xl-12">
        {(isBannerAdding || isBannerFetchingById) && <>
            <div className='loading'>
                <div className='loader'>
                    <BounceLoader loading={true} size={60} color='#34bfa3'/>
                    <span className="loading-text">Loading...</span>
                </div>
            </div>
        </>}
        <div className="m-portlet">
            <WidgetHead label={isEditMode ? "Edit Banner" : "Add Banner"}/>
                {isBannerAdded && <>
                    <div className='loading'>
                        <div className='loader'>
                            <span className="loading-text">{isBannerAddedd}</span>
                        </div>
                    </div>
                </>}
            <div className="d-flex m-3 p-1 pt-4 pb-4 banner-form">
                    <div className="col-xs-12 col-sm-12 col-lg-12 padding-remove">
                        <div className="row">
                            <div className="mb-0 form-group field-bannerform-banner_name required has-success col-xs-12 col-sm-4 col-lg-3">
                                <label className="padding-remove control-label">Banner Title</label>
                                <div className=""> 
                                    <input type="text" className="form-control form-control-edit" placeholder="Banner Title" value={title} onChange={(e) => setTitle(e.target.value)}/>
                                    <div className="col-lg-12 padding-remove">
                                        <p className="help-block help-block-error"></p>
                                    </div>
                                </div>
                                <div className="field-bannerform-start_time required">
                                    <label className="padding-remove control-label">Start Date</label>
                                    <div className="">
                                        <input type="date" className="form-control form-control-edit" placeholder="Start date" min={currentDate} max={endDate} value={startDate} onChange={(e) => setStartDate(e.target.value)}/>
                                        <div className="col-lg-12 padding-remove">
                                            <p className="help-block help-block-error"></p>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="field-bannerform-start_time required">
                                    <label className="padding-remove control-label">Banner Order</label>
                                    <div className="">
                                        <input type="number" step="1" className="form-control form-control-edit" placeholder="Banner Order" min="1" value={bannerOrder} onChange={(e) => handleBannerOrderChange(e.target.value)}/>
                                        <div className="col-lg-12 padding-remove">
                                            <p className="help-block help-block-error"></p>
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                            <div className="col-xs-12 col-sm-4 col-lg-3">
                                <div className="form-group field-bannerpictureupload-bannerimage">
                                    <div className="">
                                        <div className="file-upload">
                                            <div className="file-select">
                                                <label className="file-select-button" id="fileName">Choose File</label>
                                                <input 
                                                    {...getInputProps()} 
                                                    style={{display: 'block', padding: '9px'}} 
                                                    className="form-control form-control-edit"
                                                    placeholder="Banner Title"
                                                    accept="image/*"
                                                    ref={fileInputRef}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group field-bannerform-end_time required">
                                    <label className="padding-remove control-label">End Date</label>
                                    <div className="">
                                        <input type="date" className="form-control form-control-edit" placeholder="End date" min={startDate} value={endDate}  onChange={(e) => e.target.value >= startDate && setEndDate(e.target.value)}/>
                                    </div>
                                </div>
                                <div className="form-group field-bannerform-end_time required">
                                    <label className="padding-remove control-label">Select Type</label>
                                    <div className="row mt-1">
                                        <div className="col-lg-3 col-12">
                                            <div className="form-check">
                                            <input 
                                                type="radio" 
                                                className="form-check-input" 
                                                value="url" 
                                                name="bannerType" 
                                                checked={bannerType === 'url'} 
                                                onChange={() => setBannerType('url')} 
                                            /> 
                                                <label className="form-check-label">URL</label>
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-12">
                                            <div className="form-check">
                                                <input type="radio" className="form-check-input" checked={bannerType === 'tracks'} value="tracks" name='bannerType' onChange={() => setBannerType('tracks')}/>
                                                <label className="form-check-label">Tracks</label>
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-12">
                                            <div className="form-check">
                                                <input type="radio" className="form-check-input" checked={bannerType === 'album'} value="album" name='bannerType' onChange={() => setBannerType('album')}/>
                                                <label className="form-check-label">Album</label>
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-12">
                                            <div className="form-check">
                                                <input
                                                    type="radio"
                                                    className="form-check-input"
                                                    checked={bannerType === 'keyword'}
                                                    value="keyword"
                                                    name='bannerType'
                                                    onChange={() => setBannerType('keyword')}
                                                />
                                                <label className="form-check-label">Keyword</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xs-12 col-sm-4 col-lg-4">
                                {bannerImage && (
                                    <div>
                                    <img src={bannerImage} alt="Selected" style={{ maxWidth: '100%', maxHeight: '400px' }} />
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12" key={'_bannerTracks'}>
                            {bannerType === 'url' && (
                                <>
                                <div className='row'>
                                    <div className='col-lg-3 mb-4'>
                                        <label className="padding-remove control-label">Banner URL</label>
                                        <div className="">
                                            <input 
                                                type="url" 
                                                className="col-12 form-control form-control-edit" 
                                                placeholder="Banner URL" 
                                                value={bannerUrl} 
                                                onChange={(e) => setBannerUrl(e.target.value)} 
                                            />
                                        </div>
                                    </div>

                                    {/* Radio buttons for target="_blank" */}
                                    <div className="col-lg-3 form-group field-bannerform-target required">
                                        <label className="padding-remove control-label">Open in New Tab</label>
                                        <div>
                                            <div className="row">
                                                <div className="col-lg-3">
                                                    <div className="form-check">
                                                        <input
                                                            type="radio"
                                                            className="form-check-input"
                                                            id="targetBlankYes"
                                                            name="targetBlank"
                                                            value="true"
                                                            checked={targetBlank === true}
                                                            onChange={() => setTargetBlank(true)}
                                                        />
                                                        <label className="form-check-label" htmlFor="targetBlankYes">
                                                            Yes
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="col-lg-3">
                                                    <div className="form-check">
                                                        <input
                                                            type="radio"
                                                            className="form-check-input"
                                                            id="targetBlankNo"
                                                            name="targetBlank"
                                                            value="false"
                                                            checked={targetBlank === false}
                                                            onChange={() => setTargetBlank(false)}
                                                        />
                                                        <label className="form-check-label" htmlFor="targetBlankNo">
                                                            No
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    </div>
                                </>
                            )}
                            {bannerType === 'tracks' && <>
                                <div className="d-flex col-12 flex-wrap mb-4" key={'_bannerTracksBtn'}>
                                    {bannerTracks && bannerTracks.length > 0 && bannerTracks.map((track) => (
                                        <div className="button-container" key={track.id+'_bannerTracks'}>
                                            <button className="close-button" key={track.id+'_bannerTracksBtn'}>{track.songName} <span className="close-icon" onClick={() => handelRemoveTrack(track)} key={track.id+'_bannerTracksBtnX'}>×</span></button>
                                        </div>
                                    ))}
                                </div>
                            </>}
                            {bannerType === 'album' && <>
                                <div className="d-flex col-12 flex-wrap mb-4" key={'_bannerTracksBtn'}>
                                    {bannerTracks && bannerTracks.length > 0 && bannerTracks.map((track) => (
                                        <div className="button-container" key={track.id+'_bannerTracks'}>
                                            <button className="close-button" key={track.id+'_bannerTracksBtn'}>{track.name} <span className="close-icon" onClick={() => handelRemoveTrack(track)} key={track.id+'_bannerTracksBtnX'}>×</span></button>
                                        </div>
                                    ))}
                                </div>
                            </>}
                            {bannerType === 'keyword' && (
                                <div className="row mb-4">
                                    <div className="col-lg-8 mb-3">
                                        <label className="padding-remove control-label">Track keywords or phrases</label>
                                        <input
                                            type="text"
                                            className="form-control form-control-edit"
                                            placeholder='e.g. "Christmas, Xmas" or "Soca 2026, Soca 2025"'
                                            value={bannerKeyword}
                                            onChange={(e) => setBannerKeyword(e.target.value)}
                                        />
                                        <small className="form-text text-muted">
                                            Enter multiple keywords or phrases separated by commas. Users clicking this banner will see tracks matching any of these keywords/phrases.
                                        </small>
                                        {keywordArray.length > 0 && (
                                            <div className="mt-2">
                                                <small className="text-muted">Keywords detected: </small>
                                                {keywordArray.map((keyword, index) => (
                                                    <span key={index} className="badge badge-info mr-1">{keyword}</span>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}
                                <div className="form-group col-lg-12 px-0" style= {{ marginBottom: '0' }}>
                                    <div className="">
                                        <button className="btn btn-sm btn-primary blue-button" disabled={((bannerUrl.length === 0 && bannerType === 'url') || (bannerTracks.length === 0 && bannerType === 'tracks') || (bannerTracks.length === 0 && bannerType === 'album') || (!hasValidKeywords && bannerType === 'keyword') || startDate.length === 0 || endDate.length === 0  || title.length === 0 || (!isEditMode && bannerImage.length === 0))} type="submit" onClick={handleSubmit}>
                                            <strong>{isEditMode ? 'Update Banner' : 'Add Banner'}</strong>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {bannerType === 'tracks' &&
                    <TrackList />
                }
                {bannerType === 'album' && <AlbumList />}
                {/* Keyword type intentionally does not render TrackList/AlbumList */}
            </div>
            </div>
        </>
}

export default withRouter(AddBanner);
